import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ShareHoldingPatternItem } from '@/src/pages/StockDetails/components/StockBarChart';
import { StockPieChart } from '../../components/StockPieChart';
import { getStocksOverview } from '@/src/services/stockDetails';
import ShimmerLoader from '@/src/pages/StockDetails/components/SkeletonLoader';
import { NoData } from '../../components/NoData';
import { useSelector } from 'react-redux';
import { selectStockDetails } from '@/src/store/reducers/stocks/stockDetailsSlice';

type Payload = {
  name: string | keyof ShareHoldingPatternItem;
  label: string;
  value: number;
  fill: string;
  date: string;
};
const PieChartContainer = styled.div`
  width: 100%;
  @media screen and (max-width: 900px) {
    width: 100%;
    border-right: none;
  }
`;
const ShareHoldings = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border: 1px solid #c6ccff;
  border-radius: 0.8em;
  padding: 1rem;
  margin-bottom: 1rem;
  @media screen and (max-width: 900px) {
    display: flex;
    flex-direction: column;
  }
`;

const Head = styled.h2`
  padding: 16px 0;
  font-family: 'neuePowerTrial-Medium';
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: #001317;
  @media screen and (max-width: 900px) {
    font-size: 16px;
    font-weight: 500;
    line-height: 19.2px;
  }
`;

// TODO: Replace `any` with specific type
/* eslint-disable sonarjs/cyclomatic-complexity */
export const Overview: React.FC = () => {
  // TODO: Replace `any` with specific type
  /* eslint-disable @typescript-eslint/no-explicit-any */
  const [overviewData, setOverviewData] = useState<any>(null);
  const [isLoading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [activeData, setActiveData] = useState<Payload>({
    name: 'promotersPer',
    label: 'Promoters',
    value: 0,
    fill: '#3F7ED3',
    date: '',
  });
  const {
    data: { cocode, exchange },
  } = useSelector(selectStockDetails);

  const companyName = document
    .getElementById('csr-stock-details-page')
    ?.getAttribute('data-companyName');

  useEffect(() => {
    if (cocode && exchange) {
      setLoading(true);
      setError(null);

      getStocksOverview(cocode, exchange.toString())
        .then((response) => {
          setOverviewData(response.data);
        })
        .catch(() => {
          setError('Failed to load stock overview data.');
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [cocode, exchange]);

  const handlePieClick = (payload: Payload) => {
    setActiveData(payload);
  };

  if (isLoading) {
    return <ShimmerLoader />;
  }

  if (error) {
    return (
      <div>
        <Head>{companyName} Share Holding Pattern</Head>
        <NoData />
      </div>
    );
  }

  if (!overviewData) {
    return (
      <div>
        <Head>{companyName} Share Holding Pattern</Head>
        <NoData />
      </div>
    );
  }

  const ShareHoldingPattern = overviewData.shareHoldingPattern;

  return (
    <div>
      <Head>{companyName} Share Holding Pattern</Head>
      <ShareHoldings>
        <PieChartContainer>
          {ShareHoldingPattern && ShareHoldingPattern.length > 0 ? (
            <StockPieChart
              activeData={activeData || null}
              onPieClick={handlePieClick}
              shareHoldingData={ShareHoldingPattern[0] || null}
            />
          ) : (
            <div>No data available for Share Holding Pattern</div>
          )}
        </PieChartContainer>
      </ShareHoldings>
    </div>
  );
};
